import { createClient } from '@supabase/supabase-js'

// Fallback to window.__env for runtime injection (Cloudflare robust fix)
const env = import.meta.env || {};
const runtimeEnv = window.__env || {};

const supabaseUrl = env.VITE_SUPABASE_URL || runtimeEnv.VITE_SUPABASE_URL;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY || runtimeEnv.VITE_SUPABASE_ANON_KEY;

console.log('🔍 Torre Debug (v2):', {
    urlSource: env.VITE_SUPABASE_URL ? 'vite' : (runtimeEnv.VITE_SUPABASE_URL ? 'window' : 'missing'),
    keySource: env.VITE_SUPABASE_ANON_KEY ? 'vite' : (runtimeEnv.VITE_SUPABASE_ANON_KEY ? 'window' : 'missing')
})

if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase URL and Key are required!')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
